import $ from 'jquery';
import Timer from '../lib/Timer';
import Service from '../lib/ajax/Service';
import Messaging from '../ui/Messaging';

class TimerHandler {
  constructor() {
    this.isMarkedUrgent = false;
    this.secondsRemaining = null;
  }

  listen() {
    $(() => {
      this.$el = $('#tn-count-down-timer');

      if (this.$el.length !== 1) {
        return;
      }

      const milliseconds = Number.parseFloat(this.$el.attr('data-tn-milliseconds-remaining'));

      this.timer = new Timer({
        milliseconds,
        update: this.onUpdate.bind(this),
        complete: this.onComplete.bind(this),
      });
      this.timer.start();
    });
  }

  onUpdate(formattedTimeRemaining, secondsRemaining) {
    if (secondsRemaining === this.secondsRemaining) {
      return;
    }

    requestAnimationFrame(() => {
      if (
        this.isMarkedUrgent === false &&
        this.timer.isUrgent(secondsRemaining)
      ) {
        this.$el.closest('.tn-timer').addClass('tn-timer-urgent');
        this.isMarkedUrgent = true;
      }

      this.secondsRemaining = secondsRemaining;
      this.$el.text(formattedTimeRemaining);
    });
  }

  onComplete() {
    const service = new Service();

    service
      .get('api/cart/timer')
      .done((milliseconds) => {
        if (milliseconds <= 0) {
          this.onConfirmed();
        } else {
          this.$el.closest('.tn-timer').removeClass('tn-timer-urgent');
          this.isMarkedUrgent = false;
          this.timer.restart(milliseconds);
        }
      })
      .fail(() => {
        setErrorMessage('There was an error checking the expiration time.');
      });
  }

  onConfirmed() {
    const service = new Service();

    service
      .post('api/session/transfer', null)
      .done(() => {
        $('.tn-cart-expired-modal').modal('show').on('hide.bs.modal', () => {
          window.location.href = window.location.href;
        });
      })
      .fail(() => {
        setErrorMessage('There was an error clearing the cart');
      });
  }

  setErrorMessage(message) {
    Messaging.clearErrors();
    Messaging.clearAlerts();
    Messaging.addError(message);
    Messaging.focusUserOnMessages();
  }
}

export default TimerHandler;


// WEBPACK FOOTER //
// ./V7/tnew/handlers/TimerHandler.js